import '../assets/beautrium-css/home.scss'
import '../assets/beautrium-css/strapi.scss'
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import queryString from 'query-string';
import Page from '../components/Page';
import { getPageLayout, getPageLayoutStrapi } from '../actions/layout/index'
import { renderLayout } from '../assets/util.layout.strapi';
// import moment from 'moment';
const frontload = async props => {
    const query = queryString.parse(props.location.search);
    return await props.getPageLayoutStrapi("home", (props.authenticated && _.get(props, "profile.role_id", 0) === 4 && query.preview) ? query.layout_id : null)
}

/**
 * Home Component
 *
 * This component represents the homepage of the application. It handles
 * rendering layout components dynamically based on the provided props and
 * manages navigation and layout updates based on query parameters.
 *
 * @extends {Component}
 *
 * @component
 * @example
 * <Home
 *   location={location}
 *   history={history}
 *   authenticated={true}
 *   profile={{ role_id: 4 }}
 *   layoutComponents={[{ type: 'header', content: 'Welcome' }]}
 *   getPageLayoutStrapi={(page, layoutId) => {}}
 * />
 *
 * @property {Object} props - The properties passed to the component.
 * @property {Object} props.location - The location object from React Router.
 * @property {string} props.location.search - The query string from the URL.
 * @property {Object} props.history - The history object from React Router for navigation.
 * @property {boolean} props.authenticated - Indicates if the user is authenticated.
 * @property {Object} props.profile - The user's profile information.
 * @property {number} props.profile.role_id - The role ID of the user.
 * @property {Array} props.layoutComponents - An array of layout components to render.
 * @property {Function} props.getPageLayoutStrapi - A function to fetch the page layout from Strapi.
 *
 * @method componentDidMount
 * Handles redirection if the user is not authenticated and tries to access a preview.
 *
 * @method componentDidUpdate
 * Handles updates to the layout when query parameters change.
 *
 * @method render
 * Renders the Home component. If `layoutComponents` are provided, it renders the layout
 * using the `renderLayout` function. Otherwise, it renders nothing.
 *
 * @returns {JSX.Element} The rendered Home component.
 */
class Home extends Component {

    componentDidMount() {
        const query = queryString.parse(this.props.location.search);
        if (query.preview && !this.props.authenticated && _.get(this.props, "profile.role_id", 0) !== 4) {
            this.props.history.push('/');
        }

        // Only fetch on client if we don't have server-rendered data
        if (!this.props.layoutComponents || this.props.layoutComponents.length === 0) {
            const layoutId = (this.props.authenticated && _.get(this.props, "profile.role_id", 0) === 4 && query.preview) ? query.layout_id : null;
            this.props.getPageLayoutStrapi("home", layoutId);
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.location.search, this.props.location.search)) {
            const prevQuery = queryString.parse(prevProps.location.search);
            const query = queryString.parse(this.props.location.search);
            if (prevQuery.preview !== query.preview || prevQuery.layout_id !== query.layout_id) {
                this.props.getPageLayoutStrapi("home", (this.props.authenticated && _.get(this.props, "profile.role_id", 0) === 4 && query.preview) ? query.layout_id : null)
            }
        }
    }

    /**
     * Renders the Home component.
     *
     * @returns {JSX.Element} The rendered Home component.
     * @property {Array} layoutComponents - An array of layout components to be rendered.
     * If `layoutComponents` is provided and contains elements, it will render the layout using `renderLayout`.
     * Otherwise, it will render nothing.
     */
    render() {
        const { layoutComponents } = this.props; //new_mats, best_mats, promotion_section
        // const query = queryString.parse(search)
        return (
            <Page id="homepage" className="">
                {/* <CouponSection history={this.props.history} /> */}
                {(layoutComponents && layoutComponents.length > 0)
                    ? renderLayout(layoutComponents)
                    : null}
            </Page>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        profile: state.prof.profile,
        layoutComponents: state.layout.layouts ? state.layout.layouts.home : [],
    }
}
export default connect(mapStateToProps, { getPageLayoutStrapi, getPageLayout })(
    frontloadConnect(frontload, {
        onMount: true,
        onUpdate: false,
        noServerRender: false,
        serverPromise: true
    })(Home)
) //getNewArrivals, setFilter, setSort, getTrendyProducts, getPromotionProducts, 
